"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomerSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_1 = require("../base/meta-data");
exports.CustomerSchema = {
    name: 'customer',
    alias: 'Customer',
    shortName: 'Customer',
    applications: ['aap', 'wayste'],
    returnType: {
        aap: transport_types_1.Customer.BaseCustomer,
        wayste: transport_types_1.Customer.BaseCustomer,
    },
    requireAllSearchTerms: true,
    searchTermGroups: [
        ['companyName'],
        ['contacts.firstName', 'contacts.lastName'],
        ['contacts.email'],
        [
            'billingAddress.addressLine1',
            'billingAddress.addressLine2',
            'billingAddress.city',
            'billingAddress.state',
            'billingAddress.zip',
        ],
    ],
    searchableAttributes: [
        {
            field: 'contacts.firstName',
            alias: 'Contact Name',
            shortName: 'Name',
            searchableByDefault: true,
            isArrayOfObjects: true,
        },
        {
            field: 'contacts.lastName',
            alias: 'Contact Name',
            shortName: 'Name',
            searchableByDefault: true,
            isArrayOfObjects: true,
        },
        {
            field: 'contacts.email',
            alias: 'Contact Email',
            shortName: 'Email',
            searchableByDefault: true,
            isArrayOfObjects: true,
        },
        {
            field: 'contacts.phoneNumber',
            alias: 'Contact Phone',
            shortName: 'Phone',
            searchableByDefault: false,
            isArrayOfObjects: true,
        },
        {
            field: 'companyName',
            alias: 'Company Name',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customerNumber',
            alias: 'Account Number',
            shortName: 'Account Number',
            searchableByDefault: false,
        },
        {
            field: 'billingAddress.addressLine1',
            alias: 'Billing Address Line 1',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.addressLine2',
            alias: 'Billing Address Line 2',
            shortName: 'Address Line 2',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.city',
            alias: 'Billing Address City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.state',
            alias: 'Billing Address State',
            shortName: 'State',
            searchableByDefault: true,
        },
        {
            field: 'billingAddress.zip',
            alias: 'Billing Address Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
    ],
    filterableAttributes: [
        {
            field: 'type',
            alias: 'Customer Type',
            shortName: 'Type',
            type: 'STRING',
            allowedOperators: 'ALL',
            options: transport_types_1.Customer.customerTypes.map((type) => ({
                value: type,
                label: transport_types_1.Customer.CustomerTypeLabels[type],
            })),
            allowsMultipleValues: true,
        },
        {
            type: 'BOOLEAN',
            field: 'taxExempt',
            alias: 'Tax Exempt',
            shortName: 'Tax Exempt',
            allowedOperators: ['IS_EQUAL_TO'],
        },
        ...meta_data_1.MetaDataFilters,
    ],
};
//# sourceMappingURL=customer.js.map